export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-100/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-line text-base text-background-50"></i>
              </span>
              <span className="text-lg font-bold text-background-50 font-heading">51黑料网</span>
            </div>
            <p className="text-sm text-background-100/50 leading-relaxed">
              51黑料网是国内领先的黑料分区内容导航平台，提供黑料一区、黑料二区及黑料大赛专区的最新分区内容与导航入口服务。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">快速导航</h4>
            <div className="flex flex-col gap-2">
              {[
                { name: '热门黑料', href: '#cards' },
                { name: '热度榜单', href: '#ranking' },
                { name: '最新动态', href: '#updates' },
                { name: '视频集锦', href: '#media' },
              ].map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="text-sm text-background-100/50 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  {link.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">分区入口</h4>
            <div className="flex flex-col gap-2">
              {[
                { name: '黑料一区', href: '#cards' },
                { name: '黑料二区', href: '#cards' },
                { name: '每日大赛', href: '#ranking' },
                { name: '话题广场', href: '#topics' },
              ].map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="text-sm text-background-100/50 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  {link.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">合作伙伴</h4>
            <p className="text-sm text-background-100/40 leading-relaxed">
              合作伙伴区域，当前暂无具体合作信息展示。如有合作意向，请通过联系方式与我们取得联系。
            </p>
          </div>
        </div>

        <div className="border-t border-background-100/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-100/40">
            &copy; 2024-2026 51黑料网 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-background-100/40">
            <span>一区二区 · 每日大赛 · 分区导航</span>
          </div>
        </div>
      </div>
    </footer>
  );
}